<template>
  <div v-if="isStaging">
    <StIcon
      v-if="isMobile"
      v-tooltip="isStagingTooltip"
      icon-name="alert"
      color="warning"
      class="mr-3"
    />
    <v-chip
      v-else
      v-tooltip="isStagingTooltip"
      pill
      color="warning"
      text-color="black"
      class="mr-5"
    >
      <StIcon icon-name="alert" />
      {{ isStagingTitleChip }}
    </v-chip>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import StIcon from '@stilingue/st-icon';

export default {
  name: 'EnvironmentInfo',
  components: {
    StIcon,
  },
  data() {
    return {};
  },
  computed: {
    isStagingTooltip() {
      return `${this.$t('components.EnvironmentInfo.label.tooltip')}`;
    },
    isStagingTitleChip() {
      return `${this.$t('components.EnvironmentInfo.label.environment')}`;
    },
    ...mapState('dashboard', [
      'isStaging',
    ]),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style scoped lang="scss">
</style>

